//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeTemplate",1,0],[1,"Blank",0,"Assemblies.SelectComponentList",0],[0,"InputName",1,0],[0,"MultipleFile",1,0],[0,"NameRule",1,0],[0,"OutputFileFolderNames",1,0],[0,"ReplaceOption",1,0],[0,"TemplateFolderNames",1,0]],[[[],"UpdateEwBlankAttributes",{},0,0],[[],"GetAttributeTemplateName",{R_:{attributeTemplateName:''}},0,0],[["numTitle","titleName"],"GetAttributeTemplateTitleNames",{},0,0],[["attributeTemplateName"],"SetAttributeTemplateName",{},1,0],[["blank"],"CreateAttributeOutputFileName",{},1,0],[[],"GetTemplateFileType",{R_:{templateFileType:''}},0,0],[["attributeTemplateName"],"SetTemplateFileType",{},1,0],[["attributeTemplateFolder"],"PopulateAttributeTemplate",{},1,0],[[],"AnalyseAttributeTemplateData",{},0,0]],[]];
SPLM.Tooling.ElectrodeEDMOutputBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ElectrodeEDMOutputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ElectrodeEDMOutputBuilder.NameOption = Object.freeze({
    "Template1" : "Template1", "Template2" : "Template2"});

SPLM.Tooling.ElectrodeEDMOutputBuilder.FileType = Object.freeze({
    "Txt" : "Txt", "Xml" : "Xml", "Ing" : "Ing", "Doc" : "Doc", "Docx" : "Docx", "Pdf" : "Pdf", "Dat" : "Dat", "Excel" : "Excel", "None" : "None"});

export default SPLM;